import React, { useState } from "react";
import { grantAnalyticsConsent } from "@/lib/analytics";

const KEY = "b24_consent";

export default function CookieConsent() {
    const [choice, setChoice] = useState(() => {
        try { return localStorage.getItem(KEY); } catch { return "essential"; }
    });
    if (choice) return null;

    const decide = (value) => {
        try { localStorage.setItem(KEY, value); } catch {}
        setChoice(value);
        if (value === "all") {
            grantAnalyticsConsent();
            if (window.__b24LoadPosthog) window.__b24LoadPosthog();
        }
    };

    return (
        <div data-testid="cookie-consent-banner" className="fixed bottom-0 inset-x-0 z-[100] p-4 sm:p-5 pointer-events-none">
            <div className="max-w-3xl mx-auto rounded-2xl bg-white border border-zinc-200 shadow-2xl p-5 sm:p-6 pointer-events-auto">
                <p className="font-heading font-bold text-sm text-zinc-900">Cookies &amp; Datenschutz</p>
                <p className="text-xs text-zinc-600 mt-1.5 leading-relaxed">
                    Wir nutzen technisch notwendige Speicherung für den Betrieb der Plattform. Mit deiner Einwilligung setzen wir
                    zusätzlich Analyse-Dienste (PostHog, Google Analytics) ein, um unser Angebot zu verbessern — dabei können Daten
                    in die USA übertragen werden. Details in der{" "}
                    <a href="/datenschutz" className="text-red-600 underline" data-testid="consent-privacy-link">Datenschutzerklärung</a>.
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                    <button data-testid="consent-accept-all" onClick={() => decide("all")} className="px-5 py-2.5 rounded-full text-sm font-bold btn-primary-grad">
                        Alle akzeptieren
                    </button>
                    <button data-testid="consent-essential-only" onClick={() => decide("essential")} className="px-5 py-2.5 rounded-full text-sm font-semibold bg-white border-2 border-zinc-300 text-zinc-700 hover:border-zinc-400 transition-colors">
                        Nur notwendige
                    </button>
                </div>
            </div>
        </div>
    );
}
